import { Row, Col, Container, Card, Button, Form, Collapse, Spinner, Image, Modal } from "react-bootstrap";
import Layout from "../../components/Layout";
import { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch, useSelector } from "react-redux";
import { deleteEmailById, getEmailList, sendEmail, getCustomersList } from "../../redux/slices/users";
import Swal from "sweetalert2";
import { contactlistUpload } from "../../redux/slices/account.service";
import Select from 'react-select';
import { managerDeleteEmailById, managerGetCustomersList, managerGetEmailList, managerSendEmail } from "../../redux/slices/managers.slice";
import edit from "../../assets/images/edit.svg"
import envelope from "../../assets/images/envelope-alt.svg"
import dateFormatter from "../../utils/dateFormatter";

const Messaging = () => {
 
    const dispatch = useDispatch()
    const isLoaded = useRef(false)

    const { user = {} } = useSelector((state) => state.auth)

    const initialState = {
        withdrawal: false,
        success: false,
        payload: {
            emails: []
        },
        isActive: 1,
        data: [],
        page: 'all',
        loading: false,
        sentMessages: [],
        customers: [],
        contactlist: null,
        selectedMessage: {}
    }

    const [state, setState] = useState(initialState)

    const email_contacts = state.customers.map((customer) => {
        return {label: `${customer.full_name} - ${customer.email}`, value: customer.email}
    })

    useEffect(() => {
        if(!isLoaded.current) {
            loadEmailData()
            loadCustomers()
            isLoaded.current = true
        }
    }, [])

    const loadEmailData = () => {
        const action = user?.user_type === 'owner' ? getEmailList() : managerGetEmailList()
        dispatch(action)
        .then((response) => {
            if(response.payload?.results) {
                let results = response.payload.results
                setState((prevState) => ({...prevState, data: results }))
            }
        })
    }

    const handleFormInput = (event) => {
        const { name, value } = event.target
        setState((prevState) => ({...prevState, payload: { ...prevState.payload, [name]:value } }))
    }

    const sendMessage = () => {
       setState((prevState) => ({...prevState, loading: true }))
       const action = user?.user_type === 'owner' ? sendEmail(state.payload) : managerSendEmail(state.payload)
       dispatch(action)
       .then((response) => {
            if(response.payload?.success && response.payload?.success === true) {
                loadEmailData()
                Swal.fire({
                    icon: 'success',
                    text: response.payload?.message || 'Message sent'
                })
                .then(() => {
                    setState((prevState) => ({...prevState, withdrawal: false }))
                })
            }
            else {
                Swal.fire({
                    icon: 'error',
                    text: response.payload?.message || 'Could not send message'
                })
            }
        })
       .finally(() => setState((prevState) => ({...prevState, loading: false })))
    }

    const confirmDelete = (id) => {
        setState((prevState) => ({...prevState, loading: true }))
        const action = user?.user_type === 'owner' ? deleteEmailById(id) : managerDeleteEmailById(id)
        dispatch(action)
       .then((response) => {
            if(response.payload?.success && response.payload?.success === true) {
                loadEmailData()
                Swal.fire({
                    icon: 'success',
                    text: response.payload?.message || 'Message deleted'
                })
            }
            else {
                Swal.fire({
                    icon: 'error',
                    text: response.payload?.message || 'Could not delete message'
                })
            }
        })
       .finally(() => setState((prevState) => ({...prevState, loading: false })))
    }

    const handleDelete = (message_id) => {
        Swal.fire({
            icon: 'warning',
            text: 'Are you sure you want to delete this?',
            showConfirmButton: true,
            confirmButtonText: "Yes, Proceed",
            showCancelButton: true,
          }).then((result) => {
              if (result.isConfirmed){
                confirmDelete(message_id);
              }
          });
    }

    const handleMailsending = () => {
        Swal.fire({
            icon: 'warning',
            text: 'Are you about sending out an email, would you like to proceed?',
            showConfirmButton: true,
            confirmButtonText: "Yes, Send",
            showCancelButton: true,
          }).then((result) => {
              if (result.isConfirmed){
                sendMessage();
              }
          });
    }

    const handleFileSelect = (event) => {
        const file = event.target.files[0];
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (e) => {
            setState((prevState) => ({...prevState, contactlist: file }))
        };
    }

    const loadCustomers = () => {
        const action = user?.user_type === 'owner' ? getCustomersList() : managerGetCustomersList()
        dispatch(action)
        .then((response) => {
            if(response.payload?.results) {
                const results = response.payload?.results
                setState((prevState) => ({...prevState, customers: results }))
            } else {
                Swal.fire({
                    title: 'Error!',
                    text: response.payload.message,
                    icon: 'error',
                    confirmButtonText: 'Ok'
                })
            }
        })
    }

    const uploadContacts = () => {
        let formdata = new FormData()
        formdata.append('contact_list', state.contactlist)
        const action = user?.user_type === 'owner' ? contactlistUpload(formdata) : contactlistUpload(formdata)
        dispatch(action)
        .then((response) => {
            if(response.payload?.success && response.payload?.success === true) {
                Swal.fire({
                    icon: 'success',
                    text: response.payload?.message || 'Contacts uploaded'
                })
            }
            else {
                Swal.fire({
                    icon: 'error',
                    text: response.payload?.message || 'Could not upload contacts'
                })
            }
        })
    }

    const handleSelect = (event) => {
        let contacts = event.map((contact) => {
            return contact.value
        })
        setState((prevState) => ({...prevState, payload: { ...prevState.payload, emails: contacts} }))
    }

    return (
        <Layout>
            <>
                <Row>
                    <Col md={3} className="bg-white full-height">
                        <Container className="p-4 py-5">
                            <h3>My mails</h3>
                            <div className="mt-3 mb-3">
                                <Button 
                                    type="button" 
                                    variant="primary" 
                                    className="mb-5"
                                    onClick={ () => setState((prevState) => ({...prevState, withdrawal: true })) }
                                >
                                    <Image src={edit} alt="edit" />
                                    <span className="px-2">Compose a mail</span>
                                </Button>
                                <nav className="email-listing">
                                    <div className="nav-item d-flex align-items-center font-bold gap-3 mb-2 mt-3">
                                        <Image src={envelope} alt="inbox" /> Inbox
                                    </div>
                                    <ul className="p-0">
                                        {
                                            state.data?.length ? (
                                                state.data?.map((item, index) => (
                                                    <li key={item.id} className="font-bold text-primary">
                                                       <button 
                                                            type="button" 
                                                            className={state.selectedMessage?.id === item.id ? 'selected btn-plain' : `btn-plain`}
                                                            onClick={() => setState((prevState) => ({...prevState, selectedMessage: item}))}
                                                        >
                                                            {item.subject}
                                                        </button> 
                                                    </li>
                                                ))
                                            ) : null
                                        }
                                    </ul>
                                </nav>
                            </div>
                        </Container>
                    </Col>
                    <Col md={9}>
                        <Container fluid className="mt-5">
                            <Collapse in={state.page === 'all'}>
                                <div>
                                    <div className="d-flex gap-2">
                                        <Button 
                                            type="button" 
                                            variant="light" 
                                            className={state.isActive === 1 ? "bg-white text-primary border-0" : "text-muted border-0"}
                                            onClick={ () => setState((prevState) => ({...prevState, isActive: 1 })) }
                                        >
                                            Broadcast mails
                                        </Button>
                                        <Button 
                                            type="button" 
                                            variant="light" 
                                            className={state.isActive === 2 ? "bg-white text-primary border-0" : "text-muted border-0"}
                                            onClick={ () => setState((prevState) => ({...prevState, isActive: 2 })) }
                                        >
                                            Personalized mails
                                        </Button>
                                    </div>
                                    <Card className="border-0 bg-transparent">
                                        <Card.Body className="p-4m mailing-list bg-transparent table-responsive-lg">
                                            {
                                                state.selectedMessage && (
                                                    <div>
                                                        <div className="d-flex m-0 align-items-center justify-content-end gap-2">
                                                            {dateFormatter(state.selectedMessage.date)} 
                                                            <button 
                                                                type="button"
                                                                className="btn-plain"
                                                                onClick={ () => handleDelete(state.selectedMessage.id) }
                                                            >
                                                                <FontAwesomeIcon icon={'trash'} className="text-danger" style={{fontSize: "18px"}} />
                                                            </button>
                                                        </div>
                                                        <p className="mt-3">
                                                            {state.selectedMessage.message}
                                                        </p>
                                                    </div>
                                                )
                                            }
                                        </Card.Body>
                                    </Card>
                                </div>
                            </Collapse>
                        </Container>
                    </Col>
                </Row>

                <Modal
                    show={state.withdrawal}
                    onHide={() => setState((prevState) => ({...prevState, withdrawal: false }))}
                    size="md"
                    backdrop="static"
                >
                    <Modal.Header className="bg-primary text-white" closeButton>
                        <Modal.Title as={"h5"}>New Mail</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            <p className="text-right">
                                <a 
                                    download={true} 
                                    href="https://bs-staging.wallx.co/biz/course_material/Contact_List.xlsx"
                                    
                                    target="_blank"
                                >
                                    Download template
                                </a>
                            </p>
                            <Row>
                                <Form.Group as={Col} md={12} lg={12} sm={12} className="mb-3">
                                    <Form.Label className="mb-0 text-sm">Contact list</Form.Label>
                                    <label htmlFor="contact_list" className="custom-file-select form-control">
                                        <FontAwesomeIcon icon="fa fa-cloud" /> Upload document
                                        <input
                                            type="file"
                                            name="contact_list"
                                            onChange={handleFileSelect}
                                            size="lg"
                                            id="contact_list"
                                            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                        />
                                    </label>
                                    <p className="px-1 m-0 text-secondary text-sm">Only .xlsx file type is allowed. Max files size 2mb</p>
                                    <button 
                                        type="button" 
                                        className="btn btn-plain btn-sm text-white bg-primary"
                                        onClick={uploadContacts}
                                        disabled={ state.contactlist === ' ' || state.contactlist === undefined ? true : false }
                                    >
                                        Upload Contacts <Spinner animation={ state.loading ? "border" : null} role="status" size="sm"></Spinner>
                                    </button>
                                </Form.Group>
                                <Form.Group as={Col} md={12} className="mb-3">
                                    <Form.Label>Type</Form.Label>
                                    <Form.Select
                                        required
                                        name="type"
                                        className="form-control"
                                        onChange={handleFormInput}
                                    >
                                        <option value="">---Select---</option>
                                        <option value="personalized">Personalized</option>
                                        <option value="broadcast">Broadcast</option>
                                    </Form.Select>
                                </Form.Group>
                                <Form.Group as={Col} md={12} className="mb-3">
                                    <Form.Label className="mb-0">Select Customers</Form.Label>
                                    <Select 
                                        name="emails" 
                                        options={email_contacts}
                                        onChange={ handleSelect }
                                        isMulti
                                        closeMenuOnSelect={false}
                                        styles={{
                                            control: (baseStyles, state) => ({
                                                ...baseStyles,
                                                height: "35px",
                                                paddingLeft: "0px"
                                            }), 
                                        }}
                                    />
                                </Form.Group>
                                <Form.Group as={Col} md={12} className="mb-3">
                                    <Form.Label>Subject</Form.Label>
                                    <Form.Control
                                        type="text"
                                        required
                                        placeholder="Subject"
                                        name="subject"
                                        onChange={handleFormInput}
                                    />
                                </Form.Group>
                                <Form.Group as={Col} md={12} className="mb-3">
                                    <Form.Label>Message</Form.Label>
                                    <textarea
                                        required
                                        rows={4}
                                        placeholder="Message"
                                        name="message"
                                        className="form-control"
                                        onChange={handleFormInput}
                                    ></textarea>
                                </Form.Group>
                                <Form.Group as={Col} md={12} className="mb-3">
                                    <Button 
                                        type="button" 
                                        variant="primary" 
                                        className="form-control"
                                        onClick={ handleMailsending }
                                    >
                                        Send mail <Spinner animation={ state.loading ? "border" : null} role="status" size="sm"></Spinner>
                                    </Button>
                                </Form.Group>
                            </Row>
                        </Form>
                    </Modal.Body>
                </Modal>
            </>
        </Layout>
    );
}

export default Messaging;